var indentation_default = {
  "indentZero": "_3DWex",
  "indentOne": "t8vt2",
  "indentTwo": "_5XJSy",
  "indentThree": "HtMsp",
  "indentFour": "TF126",
  "indentFive": "ehIv6",
  "indentSix": "Cr8lB"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
